import React, { useState } from 'react';
import test from '../../assets/image/portafolio/testbast.png';
import hipermaxi from '../../assets/image/portafolio/hipermaxi.png';
import cbn from '../../assets/image/portafolio/cbn.png';
import delivery from '../../assets/image/portafolio/flutter.jpg';
import ucb from '../../assets/image/portafolio/sczucb.png';
import happy from '../../assets/image/portafolio/happy.png';
import write from '../../assets/image/portafolio/writelbolivia.png';
import { motion } from 'framer-motion';

import ItemPortfolio from "../../widgets/itemPortfolio";
import Lightbox from "../../widgets/Lightbox";

function Portafolio() {
    const [selectedIndex, setSelectedIndex] = useState(null);

    const projects = [
        { img: test, title: "ecommerce", description: "portal / web" },
        { img: hipermaxi, title: "ecommerce", description: "portal / web" },
        { img: cbn, title: "sistema gestion calidad", description: "portal / web" },
        { img: delivery, title: "sistema delivery", description: "app / movil" },
        { img: ucb, title: "sistema universidad catolica de bolivia", description: "portal / web" },
        { img: happy, title: "Landing Page Guarderia", description: "portal / web" },
        { img: write, title: "Landing Page Write Bolivia", description: "portal / web" },
    ];

    const openLightbox = (index) => {
        setSelectedIndex(index);
        // Deshabilitar scroll cuando el lightbox está abierto
        document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
        setSelectedIndex(null);
        // Habilitar scroll
        document.body.style.overflow = 'unset';
    };

    const nextImage = () => {
        setSelectedIndex((prev) => (prev + 1) % projects.length);
    };

    const prevImage = () => {
        setSelectedIndex((prev) => (prev - 1 + projects.length) % projects.length);
    };

    return (
        <section id="portfolio" className="py-24 relative z-10">
            <div className="container mx-auto px-4 lg:px-8">
                {/* Header Section */}
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <span className="text-accent-cyan font-medium tracking-widest text-sm uppercase mb-3 block">
                        Mis Trabajos
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold font-display text-white mb-6">
                        Portafolio <br className="md:hidden" /> Destacado
                    </h2>
                    <div className="w-24 h-1 bg-gradient-to-r from-accent-blue via-accent-cyan to-accent-purple mx-auto rounded-full"></div>
                </motion.div>

                {/* Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {projects.map((item, index) => (
                        <div key={index} className="w-full">
                            <ItemPortfolio 
                                img={item.img} 
                                title={item.title} 
                                description={item.description}
                                delay={index} 
                                onClick={() => openLightbox(index)}
                            />
                        </div>
                    ))}
                </div>
            </div>
            
            {/* Background elements */}
            <div className="absolute top-1/2 left-0 w-64 h-64 bg-accent-blue/5 rounded-full blur-[80px] -z-10 transform -translate-y-1/2"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent-purple/5 rounded-full blur-[100px] -z-10"></div>

            {/* Lightbox / Gallery Overlay */}
            <Lightbox 
                images={projects}
                selectedIndex={selectedIndex}
                onClose={closeLightbox}
                onNext={nextImage}
                onPrev={prevImage}
            />
        </section>
    );
}

export default Portafolio;